import '.h{display:flex;}.ssr-plugin'
import '.a9{align-items:stretch;}.ssr-plugin'
import '.l{justify-content:center;}.ssr-plugin'
import '.i{flex-direction:column;}.ssr-plugin'
import '.cz{background:var(--shades-white);}.ssr-plugin'
import '.br{flex-grow:1;}.ssr-plugin'
import '.j{align-items:center;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.d0{justify-content:stretch;}.ssr-plugin'
import '.d1{position:sticky;}.ssr-plugin'
import '.cq{top:0px;}.ssr-plugin'
import '.d2{z-index:10;}.ssr-plugin'
import '.d3{padding-block:1rem;}.ssr-plugin'
import '.d4{height:3rem;}.ssr-plugin'
import '.z{justify-content:space-between;}.ssr-plugin'
import '.d5{flex-wrap:wrap;}.ssr-plugin'
import '.d6{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bd{margin-top:2rem;}.ssr-plugin'
import '.d7{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="h a9 l i cz"
      >
        <div className="br h j l i"
        >
          <div className="b7 h i d0 d1 cq d2 cz"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="d3 d4 h z j d5"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="d6 h i a9 bd d7 b7"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
